import { Container, Box, Button, Stack } from '@mui/material'
import CloseButton from './CloseButton';
import React ,{  useEffect, useContext,useState }from 'react'
import * as API from '../utils/APICalls'
import { AppContext } from "../context/AppProvider";

const GeneralManager = () => {
const { appData, updateAppData, userData, shops, setShops, orders, setOrders,
    currentShop, setCurrentShop, modalOpen, setModalOpen } = useContext(AppContext)

  return (
     <Container sx={{
        minHeight:'50vh',
        fontFamily:'Gilroy, sans-serif',
        padding: '0.5rem'}}>
             {/* <div style={{position:'absolute', top:'0.5rem', right:'0.5rem'}}> */}
            {/* </div> */}
            <Box sx={{display: 'flex', justifyContent:'space-between',padding: '0.5rem'}}>
            <h2>General Manager</h2>
    
                
                <CloseButton func={updateAppData}  view='dash' val={{
                            modalOpen:!modalOpen,
                            modalView:''
                        }} />
            </Box>
          <Box className='center' 
          sx={{display: 'flex', border:'1px soild #000', padding:'0.5rem',
            width: '80%', height:'50%',
            boxShadow:'0px 0px 5px 3px rgba(0, 0, 0, 0.5)',
            gap:'0.5rem',justifyContent:'center', alignItems:'center'}}>
                <Button variant='contained' 
                 sx={{height:'2rem',width:'150px',
                }}
                onClick={()=>{
                    updateAppData({
                        modalView:'artists'
                    })
                }}
                >
                    Artists
                </Button>
                <Button variant='contained'
                sx={{height:'2rem',width:'150px',
                }}
                onClick={()=>{
                    updateAppData({
                        modalView:'storefronts'
                    })
                }}
                >
                           Storefronts
                        </Button>
          </Box>
        </Container>
  )
}

export default GeneralManager